import React, { createContext, useState } from "react";

const UserInfoContext = createContext();

const UserInfoContextProvider = ({ children }) => {
  const [currentUserInfo, setCurrentUserInfo] = useState({
    display_name: "XXXXXXXXX",
    uid: "XXXXXXXXXXXX",
    created_at: "2024-10-03 15:11:01",
    email: "XXXXXXXXXXXXXXXX@gmail.com",
    count: 100,
    collections: [],
  });

  return (
    <UserInfoContext.Provider value={{ currentUserInfo, setCurrentUserInfo }}>
      {children}
    </UserInfoContext.Provider>
  );
};

export { UserInfoContextProvider, UserInfoContext };
